import { Redirect, Route, type RouteComponentProps, Switch, useParams } from "react-router-dom";
import { Routes } from "@/lib/router";
import { ProjectLayout } from "@/routes/app/project/[id]/layout";
import { ProjectInfoTab } from "@/routes/app/project/[id]/tabs/info";
import { ProjectOverviewTab } from "@/routes/app/project/[id]/tabs/overview";
import { ProjectShifts } from "@/routes/app/project/[id]/tabs/shifts";

export function ProjectRouter(props: RouteComponentProps) {
  const { id } = useParams<{ id: string }>();
  const { location } = props;

  return (
    <ProjectLayout>
      <Switch location={location}>
        <Route
          exact
          path={Routes.ProjectOverview.pattern}
          render={() => {
            return <ProjectOverviewTab projectId={id} />;
          }}
        />
        <Route
          exact
          path={Routes.ProjectInfo.pattern}
          render={() => {
            return <ProjectInfoTab projectId={id} />;
          }}
        />
        <Route
          exact
          path={Routes.Project.pattern}
          render={() => {
            return <Redirect to={Routes.ProjectOverview({ id })} />;
          }}
        />
        <Route
          exact
          path={Routes.ProjectShifts.pattern}
          render={() => {
            return <ProjectShifts projectId={id} />;
          }}
        />
      </Switch>
    </ProjectLayout>
  );
}
